var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "order-status-content" }, [
    _c("div", {
      staticClass: "order-status-bullet",
      class:
        "order-status-bullet-" +
        _vm.statusNameBullet.replace(" ", "-").toLowerCase(),
    }),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "order-status-cards",
        staticStyle: {
          "border-radius": "4px !important",
          border: "1px solid #dee5ec",
        },
        attrs: { shadow: "never" },
      },
      [
        _c("div", { staticClass: "order-status-info" }, [
          _c("div", { staticClass: "order-status-name" }, [
            _vm._v("\n        " + _vm._s(_vm.statusName) + "\n      "),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "order-status-subtext" }, [
            _vm.statusNameBullet === _vm.CANCELLED ||
            _vm.statusNameBullet == _vm.ORDER_RECEIVED
              ? _c("div", [
                  _vm._v("\n          " + _vm._s(_vm.subtext) + "\n        "),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.statusNameBullet === _vm.SHIPPED
              ? _c("div", [
                  _vm._v("\n          UPS:  "),
                  _c(
                    "a",
                    {
                      attrs: {
                        href:
                          "https://www.swiship.com/track/?id=" + _vm.subtext,
                        target: "_blank",
                      },
                    },
                    [_vm._v(_vm._s(_vm.subtext))]
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.statusNameBullet === _vm.RETURN_CREATED
              ? _c("div", [
                  _vm._v("\n          Return  "),
                  _c(
                    "a",
                    {
                      attrs: { href: "" },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.openPopup(_vm.subtext)
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n            #" + _vm._s(_vm.subtext) + "\n          "
                      ),
                    ]
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.subtext2 !== null
              ? _c("div", [
                  _vm._v("\n          " + _vm._s(_vm.subtext2) + "\n        "),
                ])
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "order-status-datetime" }, [
            _vm._v(
              "\n        " +
                _vm._s(
                  _vm._f("moment")(
                    _vm.dateTimeWithTimezone,
                    "MMM DD, YYYY [at] hh:mm A"
                  )
                ) +
                "\n      "
            ),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }